import { useQuery } from "@tanstack/react-query";
import { getAccountBalance } from "@/api/v1-jwt/account/account";
import { useAuth } from "@/providers/auth";

export function useAccountBalance({
  queryFn,
  queryKey,
  enabled,
  ...rest
} = {}) {
  const { cognitoId, clientId, userRole } = useAuth();
  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false && userRole !== "customer";

  return useQuery({
    queryKey: ["platform", id, "balance"],
    queryFn: () => getAccountBalance(id),
    staleTime: Infinity,
    enabled: isEnabled,
    ...rest,
  });
}
